import React from 'react';
import App from 'common/backbone-app';
import AFBanner from 'common/AFBanner';
import classnames from 'classnames';
import { useBreakpoint } from 'utilities/hooks';
import { LogoConnect, LogoTreatwell } from 'components/common/IconPicture';
import { LoginLanguageSelect } from './LoginLanguageSelect';
import { LoginForm } from './LoginForm';
import { LoginFooter } from './LoginFooter';
import { LoginAnalytics } from './tracking';
import { Helmet } from 'react-helmet';
import style from './LoginPage.scss';

interface Props {
  route: string;
}

export const LoginPage: React.FC<Props> = ({ route }) => {
  function renderSeoLinks() {
    const alternates = {
      at: 'de-AT',
      be: 'fr-BE',
      ch: 'de-CH',
      'co.uk': 'en-GB',
      de: 'de-DE',
      es: 'es-ES',
      fr: 'fr-FR',
      gr: 'el-GR',
      ie: 'en-IE',
      it: 'it-IT',
      lt: 'lt-LT',
      nl: 'nl-NL',
      pt: 'pt-PT',
    };
    const baseUrl = 'https://connect.treatwell.';
    return (
      <Helmet>
        <link rel="canonical" href={window.location.href} />
        {Object.entries(alternates).map(([domain, hrefLang]) => (
          <link
            key={domain}
            rel="alternate"
            href={`${baseUrl}${domain}/login`}
            hrefLang={hrefLang}
          />
        ))}
      </Helmet>
    );
  }

  const isMobile = useBreakpoint('mobile');
  const banner = new AFBanner();
  banner.init('js-mobile-banner');
  const containerClass = classnames(style.container, {
    [style.isMobile]: isMobile,
  });
  React.useEffect(() => {
    App.hideLoadingIndicator();
    LoginAnalytics.trackPageView();
  }, []);

  return (
    <>
      {renderSeoLinks()}
      <div className={style.page}>
        <div className={containerClass}>
          <div className={style.header}>
            <LoginLanguageSelect />
          </div>
          <div className={style.loginContainer}>
            <h1 className={style.logo}>
              <LogoTreatwell className={style.icon} />
              <LogoConnect className={style.icon} />
            </h1>
            <LoginForm route={route} />
          </div>
          <LoginFooter />
        </div>
        <div className={style.hero} />
      </div>
    </>
  );
};
